import styles from './logo.module.css'
import type { LogoProps } from './LogoHorizontal'
import { STACKED_TEXT } from './logoPaths'
import { MARK_PATHS } from './markPaths'

/**
 * The primary stacked lockup (resources/tally4244-logo-stacked.svg): mark above
 * wordmark above the ruled descriptor. Used on the login and sign-in screens.
 */
export function LogoStacked({ productName, className, title }: LogoProps) {
  const label = title ?? productName
  return (
    <svg
      viewBox="230 60 1140 480"
      className={`${styles.logo} ${className ?? ''}`}
      role="img"
      aria-label={label}
    >
      <title>{label}</title>
      <g
        transform="translate(713 75)"
        className={styles.mark}
        fill="none"
        stroke="currentColor"
        strokeWidth={18}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {MARK_PATHS.map((d) => (
          <path key={d} d={d} />
        ))}
      </g>
      <path d={STACKED_TEXT.wordmarkLetters} className={styles.wordmark} />
      <path d={STACKED_TEXT.wordmarkDigits} className={styles.digits} />
      <line x1="250" y1="502" x2="360" y2="502" strokeWidth={4} className={styles.rule} />
      <line x1="1240" y1="502" x2="1350" y2="502" strokeWidth={4} className={styles.rule} />
      <path d={STACKED_TEXT.descriptor} className={styles.descriptor} />
    </svg>
  )
}
